import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import logo from "./assets/logo.png";
import { AMIRI_BASE64 } from "./assets/fonts/Amiri-Regular.base64";

const fmt = (v) => (v == null ? "" : String(v));
const pad = (n) => {
  const x = String(n || "");
  return x.length === 1 ? `0${x}` : x;
};

/**
 * Ø¯Ø§Ù„Ø© Ù…Ø³Ø§Ø¹Ø¯Ø© Ù„Ø¬Ù„Ø¨ Ø§Ù„Ù‚ÙŠÙ…Ø© Ø³ÙˆØ§Ø¡ ÙƒØ§Ù†Øª snake_case Ø£Ùˆ camelCase
 */
function getV(obj, key) {
  if (!obj) return "";
  const camel = key.replace(/_([a-z])/g, g => g[1].toUpperCase());
  return obj[key] !== undefined ? obj[key] : (obj[camel] !== undefined ? obj[camel] : "");
}

function fmtNum(v, decimals = 0) {
  if (v == null || v === "") return "";
  const n = Number(v);
  if (Number.isNaN(n)) return String(v);
  return n.toLocaleString("en-US", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
}

const formatDate = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return fmt(value);
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
};

export default function generateAirCargoManifestPdf({ header, bols, totals, user, title = "AIR CARGO MANIFEST", fileNamePrefix = "AirCargoManifest" }) {
  const doc = new jsPDF({ orientation: "p", unit: "pt", format: "a4" });
  doc.addFileToVFS("Amiri-Regular.ttf", AMIRI_BASE64);
  doc.addFont("Amiri-Regular.ttf", "Amiri", "normal");
  doc.setFont("Amiri", "normal");
  const pageW = doc.internal.pageSize.getWidth();
  const margin = 40;

  // Normalize lines so callers can pass either flat rows or masters with nested homes.
  // Also dedupe rows because some flows may pass both forms at once.
  const normalizedBols = (() => {
    const raw = Array.isArray(bols)
      ? bols.flatMap((b) => [b, ...(Array.isArray(b?.homes) ? b.homes : [])])
      : [];

    const seen = new Set();
    const out = [];
    raw.forEach((row) => {
      const key =
        String(getV(row, "id") || "") ||
        `${String(getV(row, "parent_bol_id") || "0")}|${String(getV(row, "bol_reference") || getV(row, "bolReference") || "")}|${String(getV(row, "is_house") || "0")}`;
      if (!seen.has(key)) {
        seen.add(key);
        out.push(row);
      }
    });
    return out;
  })();
  const firstLine = normalizedBols.find((b) => !getV(b, "parent_bol_id")) || normalizedBols[0] || {};

  const resolvedRegistration =
    getV(header, "registration") ||
    getV(firstLine, "aircraft_registration_from_bols") ||
    getV(firstLine, "aircraft_registration") ||
    getV(firstLine, "registration") ||
    "";

  const resolvedLoading =
    getV(header, "place_of_departure_code") ||
    getV(firstLine, "port_of_loading_from_bols") ||
    getV(firstLine, "port_of_loading") ||
    getV(firstLine, "place_of_loading_code") ||
    "";

  const resolvedUnloading =
    getV(header, "place_of_destination_code") ||
    getV(firstLine, "port_of_discharge_from_bols") ||
    getV(firstLine, "port_of_discharge") ||
    getV(firstLine, "place_of_unloading_code") ||
    "";

  // 1. Logo (Ù†ÙØ³ Ù…Ù‚Ø§Ø³Ø§Øª ÙˆØªÙˆØ³ÙŠØ· Ø§Ù„ÙØ§ØªÙˆØ±Ø©)
  const logoWidth = 180;
  const logoHeight = 45;
  const logoX = (pageW - logoWidth) / 2;
  const logoY = 20;
  doc.addImage(logo, "PNG", logoX, logoY, logoWidth, logoHeight);
  const preparedDate = formatDate(new Date());

  // 2. Titles
  doc.setFontSize(16);
  doc.setFont("Amiri", "bold");
  doc.text(title, pageW / 2, logoY + logoHeight + 30, { align: "center" });

  doc.setFontSize(10);
  doc.setFont("Amiri", "normal");
  doc.text("I.C.A.O. Annex 9, Appendix 3", pageW / 2, logoY + logoHeight + 45, { align: "center" });
  doc.text(`Date prepared: ${preparedDate}`, pageW / 2, logoY + logoHeight + 60, { align: "center" });
  doc.text("Page: 01", pageW / 2, logoY + logoHeight + 75, { align: "center" });

  // 3. Info Grid (ØªÙˆØ²ÙŠØ¹ Ø§Ù„Ø­Ù‚ÙˆÙ„ Ø¨Ù†ÙØ³ Ø£Ø³Ù„ÙˆØ¨ Ø§Ù„ÙØ§ØªÙˆØ±Ø©)
  const infoStartY = logoY + logoHeight + 100;
  let infoCurrentY = infoStartY;
  const col1X = margin;
  const col2X = pageW / 2 + 50;
  const lineHeight = 14;
  const firstBolWithEtd = normalizedBols.find((b) => getV(b, "etd") || getV(b, "etd_from_bols") || getV(b, "etdFromBols")) || null;
  const manifestEtd = getV(header, "etd") || getV(firstBolWithEtd, "etd") || getV(firstBolWithEtd, "etd_from_bols") || getV(firstBolWithEtd, "etdFromBols") || "";

  doc.setFontSize(10);
  doc.setFont("Amiri", "bold");

  // Row 1
  doc.setFont("Amiri", "bold");
  doc.text("Owner or Operator:", col1X, infoCurrentY);
  doc.setFont("Amiri", "normal");
  doc.text(fmt(getV(header, "owner_operator") || "TARCO AVIATION"), col1X + 100, infoCurrentY);
  doc.setFont("Amiri", "bold");
  doc.text("Prepared by:", col2X, infoCurrentY);
  doc.setFont("Amiri", "normal");
  doc.text(fmt(user?.username || "Admin"), col2X + 80, infoCurrentY);
  infoCurrentY += lineHeight;

  // Row 2
  doc.setFont("Amiri", "bold");
  doc.text("Registration:", col1X, infoCurrentY);
  doc.setFont("Amiri", "normal");
  doc.text(fmt(resolvedRegistration || "___________"), col1X + 80, infoCurrentY);
  doc.setFont("Amiri", "bold");
  doc.text("Manifest No:", col2X, infoCurrentY);
  doc.setFont("Amiri", "normal");
  doc.text(fmt(getV(header, "id") || "___________"), col2X + 80, infoCurrentY);
  infoCurrentY += lineHeight;

  // Row 3
  doc.setFont("Amiri", "bold");
  doc.text("Point of Loading:", col1X, infoCurrentY);
  doc.setFont("Amiri", "normal");
  doc.text(fmt(resolvedLoading || "___________"), col1X + 100, infoCurrentY);
  doc.setFont("Amiri", "bold");
  doc.text("Customs Ref:", col2X, infoCurrentY);
  doc.setFont("Amiri", "normal");
  doc.text(fmt(getV(header, "customs_office_code") || "___________"), col2X + 80, infoCurrentY);
  infoCurrentY += lineHeight;

  // Row 4: Flight No & Unloading
  doc.setFont("Amiri", "bold");
  doc.text("Flight No:", col1X, infoCurrentY);
  doc.setFont("Amiri", "normal");
  doc.text(fmt(getV(header, "voyage_number") || getV(header, "flight_no") || "___________"), col1X + 80, infoCurrentY);
  doc.setFont("Amiri", "bold");
  doc.text("Point of Unloading:", col2X, infoCurrentY);
  doc.setFont("Amiri", "normal");
  doc.text(fmt(resolvedUnloading || "___________"), col2X + 100, infoCurrentY);
  infoCurrentY += lineHeight;

  // Row 5: ETD
  doc.setFont("Amiri", "bold");
  doc.text("ETD:", col2X, infoCurrentY);
  doc.setFont("Amiri", "normal");
  doc.text(fmt(manifestEtd) || "___________", col2X + 80, infoCurrentY);
  infoCurrentY += lineHeight;

  let tableStartY = infoCurrentY + 20;

  // 4. Grouping & Table Logic (Ø¨Ø¯ÙˆÙ† Ù…Ø¨Ø§Ù„Øº)
  let totalPieces = 0;
  let totalKg = 0;
  let totalVol = 0;
  const getGrossMassValue = (row) => Number(getV(row, "gross_mass") || 0);
  const getVolByMc = (row) => Number(getV(row, "vol_by_mc") || getV(row, "volByMc") || 0);
  const getOd = (row) => {
    const loading = getV(row, "place_of_loading_code") || resolvedLoading || "";
    const unloading = getV(row, "place_of_unloading_code") || resolvedUnloading || "";
    if (!loading && !unloading) return "";
    return `${fmt(loading)}-${fmt(unloading)}`;
  };
  const masterGroups = [];
  if (normalizedBols.length > 0) {
    // ØªØ­Ø¯ÙŠØ¯ Ø§Ù„Ù…Ø§Ø³ØªØ±: Ø£ÙŠ Ø¨ÙˆÙ„ÙŠØµØ© Ù„Ø§ ØªÙ…Ù„Ùƒ parent_bol_id
    const masters = normalizedBols.filter(b => !getV(b, "parent_bol_id"));
    const houseMap = new Map();
    // ØªØ¬Ù…ÙŠØ¹ Ø§Ù„Ù‡Ø§ÙˆØ³Ø§Øª Ø¨Ù†Ø§Ø¡Ù‹ Ø¹Ù„Ù‰ Ø§Ù„Ø±Ù‚Ù… Ø§Ù„ØªØ¹Ø±ÙŠÙÙŠ Ù„Ù„Ø£Ø¨
    normalizedBols.filter(b => !!getV(b, "parent_bol_id")).forEach((h) => {
      const pid = getV(h, "parent_bol_id");
      if (!houseMap.has(pid)) houseMap.set(pid, []);
      houseMap.get(pid).push(h);
    });
    masters.forEach(master => {
      const masterCopy = { ...master };
      delete masterCopy.homes; 
      const mid = getV(master, "id");
      masterGroups.push({ master: masterCopy, houses: houseMap.get(mid) || [] });
 });
  }

  const bodyWithMeta = [];
  // ØµÙ ØªØ¬Ù…ÙŠÙ„ÙŠ BULK
  bodyWithMeta.push([{ content: "BULK CARGO", colSpan: 7, styles: { fontStyle: "bold" } }]);

  masterGroups.forEach(group => {
    const { master, houses } = group;
    
    // âœ… Ù…Ù†Ø·Ù‚ Ø§Ù„ØªØ¬Ù…ÙŠØ¹ Ø§Ù„ØµØ­ÙŠØ­:
    // Ø¥Ø°Ø§ ÙƒØ§Ù†Øª Ø§Ù„Ø¨ÙˆÙ„ÙŠØµØ© ØªØ­ØªÙˆÙŠ Ø¹Ù„Ù‰ Ù‡Ø§ÙˆØ³Ø§ØªØŒ Ù†Ø¬Ù…Ø¹ Ø£ÙˆØ²Ø§Ù† Ø§Ù„Ù‡Ø§ÙˆØ³Ø§Øª ÙÙ‚Ø· ÙˆÙ†Ø³ØªØ«Ù†ÙŠ Ø§Ù„Ù…Ø§Ø³ØªØ± Ù…Ù† Ø§Ù„Ø¬Ù…Ø¹ Ù„ØªØ¬Ù†Ø¨ Ø§Ù„ØªÙƒØ±Ø§Ø±.
    // Ø¥Ø°Ø§ ÙƒØ§Ù†Øª Ø¨ÙˆÙ„ÙŠØµØ© Ù…Ø¨Ø§Ø´Ø±Ø© (Ø¨Ø¯ÙˆÙ† Ù‡Ø§ÙˆØ³)ØŒ Ù†Ø¬Ù…Ø¹ Ø§Ù„Ù…Ø§Ø³ØªØ±.
    if (houses && houses.length > 0) {
      houses.forEach(h => {
        totalPieces += Number(getV(h, "number_of_packages") || 0);
        totalKg += getGrossMassValue(h);
        totalVol += getVolByMc(h);
      });
    } else {
      totalPieces += Number(getV(master, "number_of_packages") || 0);
      totalKg += getGrossMassValue(master);
      totalVol += getVolByMc(master);
    }

    // Ø¥Ø¶Ø§ÙØ© Ø§Ù„Ù…Ø§Ø³ØªØ± (Ø¨Ø®Ø· Ø¹Ø±ÙŠØ¶ Ù„Ù„ØªÙ…ÙŠÙŠØ²)
    bodyWithMeta.push([
      { content: fmt(getV(master, "bol_reference")), styles: { fontStyle: 'bold' } },
      fmtNum(getV(master, "number_of_packages")),
      `${fmtNum(getGrossMassValue(master), 2)} KG`,
      fmtNum(getVolByMc(master), 2),
      fmt(getV(master, "goods_description")),
      getOd(master),
      fmt(master.official_use || "J EAP SPX.")
    ]);

    // Ø¥Ø¶Ø§ÙØ© Ø§Ù„Ù‡Ø§ÙˆØ³Ø§Øª (Ø¨Ø¥Ø²Ø§Ø­Ø© ÙˆØ³Ù‡Ù… ØªÙ…ÙŠÙŠØ² ÙˆÙ„ÙˆÙ† Ø£Ø®Ù Ù‚Ù„ÙŠÙ„Ø§Ù‹)
    houses.forEach(house => {
      bodyWithMeta.push([
        { 
          content: `   * ${fmt(getV(house, "bol_reference"))}`, 
          styles: { fontStyle: 'italic', textColor: [80, 80, 80] } 
        },
        fmtNum(getV(house, "number_of_packages")),
        `${fmtNum(getGrossMassValue(house), 2)} KG`,
        fmtNum(getVolByMc(house), 2),
        fmt(getV(house, "goods_description")),
        getOd(house),
        fmt(house.official_use || "J EAP SPX.")
      ]);
    });
  });

  const tableHeaders = ["Air waybill", "pieces", "weight", "VOL BY MC", "nature of goods", "O-D", "official use"];
  const tableWidth = pageW - (margin * 2);
  const columnWidths = {
    0: tableWidth * 0.20,
    1: tableWidth * 0.10,
    2: tableWidth * 0.14,
    3: tableWidth * 0.14,
    4: tableWidth * 0.26,
    5: tableWidth * 0.08,
    6: tableWidth * 0.08,
  };

  autoTable(doc, {
    startY: tableStartY,
    head: [tableHeaders],
    body: bodyWithMeta,
    theme: "plain",
    styles: { fontSize: 9, cellPadding: 5, textColor: [0, 0, 0], font: "Amiri" },
    headStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], fontStyle: "bold" },
    bodyStyles: {},
    columnStyles: {
      0: { cellWidth: columnWidths[0], halign: 'left' },
      1: { cellWidth: columnWidths[1], halign: 'center' },
      2: { cellWidth: columnWidths[2], halign: 'center' },
      3: { cellWidth: columnWidths[3], halign: 'center' },
      4: { cellWidth: columnWidths[4], halign: 'left' },
      5: { cellWidth: columnWidths[5], halign: 'center' },
      6: { cellWidth: columnWidths[6], halign: 'center' }
    },
    didParseCell: (data) => {
      if (data.section !== 'head' || data.row.index !== 0) return;

      // Keep header alignment identical to the body to prevent visual drift.
      if (data.column.index === 1) data.cell.styles.halign = 'center';
      if (data.column.index === 2) data.cell.styles.halign = 'center';
      if (data.column.index === 3) data.cell.styles.halign = 'center';
      if (data.column.index === 4) data.cell.styles.halign = 'left';
      if (data.column.index === 5 || data.column.index === 6) data.cell.styles.halign = 'center';
    },
    didDrawCell: (data) => {
      if (data.section !== "head" || data.row.index !== 0 || data.column.index !== 0) return;
      const x1 = margin;
      const x2 = pageW - margin;
      const yTop = data.cell.y - 0.5;
      const yBottom = data.cell.y + data.cell.height + 0.5;

      doc.setDrawColor(0, 0, 0);
      doc.setLineWidth(1.1);
      doc.line(x1, yTop, x2, yTop);
      doc.line(x1, yBottom, x2, yBottom);
    },
  });

  // 5. Final Totals (Ø­Ø³Ø§Ø¨ Ø§Ù„Ù…Ø¬Ù…ÙˆØ¹ Ù…Ù† Ø§Ù„Ù…Ø§Ø³ØªØ± ÙÙ‚Ø· Ù„ØªØ¬Ù†Ø¨ Ø§Ù„ØªÙƒØ±Ø§Ø±)
  const finalY = doc.lastAutoTable.finalY + 30;
  doc.setFont("Amiri", "bold");
  doc.setFontSize(10);
  doc.text(`TOTAL:          ${fmtNum(totalPieces)} PCS          ${fmtNum(totalKg, 2)} KG          ${fmtNum(totalVol, 2)} VOL`, margin, finalY);

  const safeTitle = fileNamePrefix.replace(/[^a-zA-Z0-9_-]/g, "");
  const fileName = `${safeTitle}_${fmt(getV(header, "voyage_number") || getV(header, "id"))}_${formatDate(getV(header, "date_of_arrival"))}.pdf`;
  doc.save(fileName);
}

